import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@mui/material';
import styles from './loading-styles.js';
const useStyles = makeStyles(styles);

export default function (props) {
    const classes = useStyles();

    let { color } = props;

    if (props.full) {
      return (
        <div className={classes.root}>
          <CircularProgress className={classes.progressSmall} />
        </div>
      );
    } else {

      if (color === 'light') {
        return (
          <div className={classes.rootSmall}>
            <CircularProgress className={classes.progressSmallLight} />
          </div>
        );
      }
      return (
        <div className={classes.rootSmall}>
          <CircularProgress className={classes.progressSmall} />
        </div>
      );
    }
    
}